import {
    CheckboxVisibility,
    Selection,
    CommandBar,
    DetailsList,
    DetailsRow,
    ICommandBarItemProps,
    IDetailsListProps,
    IDetailsRowStyles,
    MarqueeSelection,
    SelectionMode,
    Stack,
    IObjectWithKey,
    FontIcon,
} from "@fluentui/react";
import themeBase from "../../../utils/theme/themeBase";
import { _onRenderHeaderAllheight } from "../../../utils/helpers/helpers";
import IconHelper from "../../../utils/helpers/iconHelper";
import DefaultSelect from "../../../components/generic/defaultSelect";
import { useEffect, useState } from "react";
import BaseTelelirk from "../../../components/generic/baseTelerik";
import COLORES from "../../../utils/theme/colores";
import { BaseTelerikV1, EViewMode } from "../../../components/generic/baseTelerikV1";
import { BaseReportesTelerik } from "../../../components/generic/baseReportesTelerik";
import { TabletsAsignados } from "./TabletsAsignados";
import { ChecklistValidados } from "./ChecklistValidados";
import { IpercValidados } from "./IpercValidados";
import { RankingSupervisor } from "./RankingSupervisor";
import { BaseReportesTelerikV2 } from "../../../components/generic/baseReportesTelerikV2";
import { TacosSeguridad } from "./TacosSeguridad";

interface ITelerikReport {
    key: string;
    nombre: string;
    isParameter: boolean;
    iconName?: string;
    parameters?: {};
    isFiltros: boolean;
}

interface ISSOMARankingSupervisorValidaciones {
    Estado: Estados;
    Documento: Documentos;
}

enum Estados {
    Pendientes = "Pendientes",
    Verificados = "Verificados",
}

enum Documentos {
    IPERC = "IPERC",
    Checklist = "Checklist",
}

const myTelerikReports: ITelerikReport[] = [
    {
        key: "SSOMAUsuariosEnrolados.trdx",
        nombre: "Usuarios Enrolados",
        isParameter: false,
        iconName: "PDF",
        isFiltros: false,
    },
    {
        key: "SSOMAReporteDispositivos.trdx",
        nombre: "Dispositivos",
        isParameter: false,
        iconName: "PDF",
        isFiltros: false,
    },
    {
        key: "SSOMATabletsAsignados.trdx",
        nombre: "Tablets Asignados",
        isParameter: false,
        iconName: "PDF",
        isFiltros: true,
    },
    {
        key: "SSOMAEquiposAutorizados.trdx",
        nombre: "Equipos Autorizados",
        isParameter: false,
        iconName: "PDF",
        isFiltros: false,
    },
    {
        key: "SSOMARankingSupervisorValidaciones.trdx",
        nombre: "Validacion Supervisores",
        isParameter: true,
        iconName: "PDF",
        parameters: {
            Estado: Estados.Verificados,
            Documento: Documentos.IPERC,
        },
        isFiltros: true,
    },
    {
        key: "SSOMAReporteChecklist.trdx",
        nombre: "Checklist Validados",
        isParameter: false,
        iconName: "PDF",
        isFiltros: true,
    },
    {
        key: "SSOMAReporteIPERC.trdx",
        nombre: "IPERC Validados",
        isParameter: false,
        iconName: "PDF",
        isFiltros: true,
    },
    {
        key: "SSOMAReporteChecklist_TacosSeguridad.trdx",
        nombre: "Tacos de Seguridad",
        isParameter: true,
        iconName: "PDF",
        isFiltros: true,
        parameters: {
            FechaInicio: null,
            FechaFin: null,
        },
    }
];

function VistaListaReportes() {
    //#region SELECCION ELEMENTO
    const [itemSeleccionado, setItemSeleccionado] = useState<IObjectWithKey>();
    const [itemSeleccionadoValue, setItemSeleccionadoValue] =
        useState<ITelerikReport>();
    const _selection = new Selection({
        onSelectionChanged: () => {
            setItemSeleccionado(_selection.getSelection()[0]);
        },
    });

    useEffect(() => {
        if (itemSeleccionado) {
            let itemValue = itemSeleccionado as ITelerikReport;
            setItemSeleccionadoValue(itemValue);
        }
        //console.log(itemSeleccionadoValue)
    }, [itemSeleccionado]);
    //#endregion

    //#region ICONO DE FILTRO
    const itemsFilter = (): ICommandBarItemProps[] => {
        let icon: ICommandBarItemProps[] = [
            {
                ...IconHelper.ICON_BS_FILTER_DISABLED,
                text: "Filtrar",
            },
        ];
        if (itemSeleccionadoValue?.isFiltros) {
            // AQUI SE DEBE RETORNAR EL MENU FILTRO SEGUN REPORTE
            let icon2: ICommandBarItemProps[] = [
                {
                    ...IconHelper.ICON_BS_FILTER,
                    subMenuProps: {
                        items: [
                            {
                                key: "Estado",
                                text: "Estado",
                                iconProps: { iconName: "Clock" },
                                subMenuProps: {
                                    items: [
                                        {
                                            key: "Verificados",
                                            text: "Verificados",
                                            iconProps: { iconName: "ReminderTime" },
                                            onClick(ev, item) {
                                                let aux = {
                                                    ...itemSeleccionadoValue,
                                                    parameters: {
                                                        ...itemSeleccionadoValue.parameters,
                                                        Estado: Estados.Verificados,
                                                    },
                                                } as ITelerikReport;
                                                let don = item?.text
                                                setItemSeleccionadoValue(aux);
                                            },
                                        },
                                        {
                                            key: "Pendientes",
                                            text: "Pendientes",
                                            iconProps: {
                                                iconName: "StatusCircleBlock",
                                                color: "#ttt",
                                            },
                                            onClick(ev, item) {
                                                let aux = {
                                                    ...itemSeleccionadoValue,
                                                    parameters: {
                                                        ...itemSeleccionadoValue.parameters,
                                                        Estado: Estados.Pendientes,
                                                    },
                                                } as ITelerikReport;

                                                setItemSeleccionadoValue(aux);
                                            },
                                        },
                                    ],
                                },
                            },
                            {
                                key: "Formato",
                                text: "Formato",
                                iconProps: { iconName: "EntitlementRedemption" },
                                subMenuProps: {
                                    items: [
                                        {
                                            key: "IPERC",
                                            text: "IPERC",
                                            iconProps: { iconName: "Dialpad" },
                                            onClick(ev, item) {
                                                let aux = {
                                                    ...itemSeleccionadoValue,
                                                    parameters: {
                                                        ...itemSeleccionadoValue.parameters,
                                                        Documento: Documentos.IPERC,
                                                    },
                                                } as ITelerikReport;

                                                setItemSeleccionadoValue(aux);
                                            },
                                        },
                                        {
                                            key: "Checklist",
                                            text: "Checklist",
                                            iconProps: { iconName: "IssueTrackingMirrored" },
                                            onClick(ev, item) {
                                                let aux = {
                                                    ...itemSeleccionadoValue,
                                                    parameters: {
                                                        ...itemSeleccionadoValue.parameters,
                                                        Documento: Documentos.Checklist,
                                                    },
                                                } as ITelerikReport;

                                                setItemSeleccionadoValue(aux);
                                            },
                                        },
                                    ],
                                },
                            },
                        ],
                    },
                },
            ];
            return icon2;
        }
        return icon;
    };
    //#endregion

    const renderReportComponent = () => {
        if (!itemSeleccionadoValue) {
            return <div>Selecciona un reporte para visualizarlo</div>;
        }
        switch (itemSeleccionadoValue?.key) {
            case "SSOMATabletsAsignados.trdx":
                return (
                    <TabletsAsignados
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue?.key}
                        parametros={itemSeleccionadoValue?.parameters}
                        //parametros={itemSeleccionadoValue.isFiltros ? itemSeleccionadoValue?.parameters : {}}
                        formatos={2}
                    />
                );
            case "SSOMARankingSupervisorValidaciones.trdx":
                return (
                    // <BaseTelelirk
                    //     reportName={itemSeleccionadoValue?.key}
                    //     parametros={itemSeleccionadoValue?.parameters}
                    // />
                    <RankingSupervisor
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue?.key}
                        parametros={itemSeleccionadoValue?.parameters}
                        formatos={2}
                    />
                );
            case "SSOMAReporteChecklist.trdx":
                return (
                    // <BaseTelelirk
                    //     reportName={itemSeleccionadoValue?.key}
                    //     parametros={itemSeleccionadoValue?.parameters}
                    // />
                    <ChecklistValidados
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue?.key}
                        parametros={itemSeleccionadoValue?.parameters}
                        formatos={2}
                    />
                );
            case "SSOMAReporteIPERC.trdx":
                return (
                    // <BaseTelelirk
                    //     reportName={itemSeleccionadoValue?.key}
                    //     parametros={itemSeleccionadoValue?.parameters}
                    // />
                    <IpercValidados
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue?.key}
                        parametros={itemSeleccionadoValue?.parameters}
                        formatos={2}
                    />
                );
            case "SSOMAEquiposAutorizados.trdx":
                return (
                    // <BaseTelelirk
                    //     reportName={itemSeleccionadoValue?.key}
                    //     parametros={itemSeleccionadoValue?.parameters}
                    // />
                    <BaseReportesTelerikV2
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue?.key}
                        parametros={itemSeleccionadoValue?.parameters}
                        formatos={2}
                        viewMode="PRINT_PREVIEW"
                        // scaleMode="SPECIFIC"
                        scaleMode={"FIT_PAGE_WIDTH"}
                        scale={1.2}
                    />
                );
            case "SSOMAReporteChecklist_TacosSeguridad.trdx":
                return (
                    <TacosSeguridad
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue.key}
                        parametros={itemSeleccionadoValue.parameters}
                        formatos={2}
                    />
                );
            // Agrega más casos aquí según sea necesario
            default:
                return (
                    <BaseReportesTelerik
                        key={itemSeleccionadoValue.key}
                        reportName={itemSeleccionadoValue?.key}
                        parametros={itemSeleccionadoValue.isFiltros ? itemSeleccionadoValue?.parameters : {}}
                        formatos={2}
                    />
                );
        }
    };

    return (
        <>
            <Stack padding={5}>
                {/* {JSON.stringify("-------Reporte------", null, 1)}
                {JSON.stringify(itemSeleccionadoValue, null, 1)}
                {JSON.stringify(itemSeleccionadoValue?.key, null, 1)}
                {JSON.stringify(itemSeleccionadoValue?.parameters, null, 1)}
                {JSON.stringify("--------Reporte FIN---", null, 1)} */}
                <CommandBar
                    items={[]}
                    farItems={[]}
                    styles={themeBase.commadStylesWithPadding}
                />
            </Stack>
            <div className="ms-Grid" dir="ltr">
                <div className="ms-Grid-row">
                    {/* <div className="ms-Grid-col ms-md3 ms-lg3 ms-depth-4"> */}
                    <div className="ms-Grid-col ms-md2 ms-lg2 ms-depth-3">
                        {/* <div className="ms-Grid-col ms-lg12">
                            <CommandBar
                                items={[]}
                                farItems={itemsFilter()}
                                styles={{ root: { height: 25, padding: "6px 0 6px 0" } }}
                            />
                        </div> */}
                        <br />
                        <div className="ms-Grid-col ms-lg12">
                            <MarqueeSelection selection={_selection}>
                                <DetailsList
                                    items={myTelerikReports}
                                    columns={_columns}
                                    selectionMode={SelectionMode.single}
                                    isHeaderVisible={false}
                                    compact={true}
                                    styles={_onRenderHeaderAllheight}
                                    onRenderRow={_onRenderRow}
                                    selection={_selection}
                                    checkboxVisibility={CheckboxVisibility.hidden}
                                />
                            </MarqueeSelection>
                        </div>
                    </div>
                    {itemSeleccionadoValue ? (
                        // <div className="ms-Grid-col ms-md9  ms-lg9">
                        <div className="ms-Grid-col ms-md10  ms-lg10">
                            {/* {itemSeleccionadoValue.isFiltros ? (
                                <BaseTelelirk
                                    reportName={itemSeleccionadoValue?.key}
                                    parametros={itemSeleccionadoValue?.parameters}
                                />
                            ) : (
                                //   <BaseTelerikV1
                                //   reportName={itemSeleccionadoValue?.key}
                                //   parametros={itemSeleccionadoValue.isParameter ? itemSeleccionadoValue?.parameters : {}}
                                //   formatos={2}
                                //   viewMode={EViewMode.PRINT_PREVIEW}
                                // /> 
                                <BaseReportesTelerik
                                    key={itemSeleccionadoValue.key}
                                    reportName={itemSeleccionadoValue?.key}
                                    parametros={itemSeleccionadoValue.isFiltros ? itemSeleccionadoValue?.parameters : {}}
                                    formatos={2}
                                />
                                // <BaseTelelirk
                                //   reportName={itemSeleccionadoValue?.key}
                                //   parametros={itemSeleccionadoValue?.parameters}
                                // />
                            )} */}
                            {itemSeleccionadoValue ? (
                                <div className="ms-Grid-col ms-md12 ms-lg12">
                                    {renderReportComponent()}
                                </div>
                            ) : (
                                <div>Selecciona un reporte para visualizarlo</div>
                            )}
                        </div>
                    ) : (
                        <DefaultSelect iconName="ExcelDocument" />
                    )}
                </div>
            </div>
        </>
    );
}

export default VistaListaReportes;

const _columns = [
    {
        key: "nombre",
        name: "Nombre",
        fieldName: "nombre",
        minWidth: 150,
        maxWidth: 250,
        isResizable: true,
        onRender: (item: ITelerikReport) => (
            <Stack verticalAlign="space-around" horizontal>
                <span style={{ marginTop: 2, fontSize: "12px" }}>
                    <FontIcon
                        iconName={item.iconName}
                        style={{
                            color: COLORES.Bases.primary,
                            marginRight: 5,
                        }}
                    />
                </span>
                <p style={{ margin: 0, fontSize: "12px" }}>{item.nombre}</p>
            </Stack>
        ),
    },
    // {
    //     key: 'value',
    //     name: 'Opciones',
    //     fieldName: 'value',
    //     minWidth: 10,
    //     maxWidth: 10,
    //     isResizable: true,
    //     onRender: (item: IIpercActividad) => (
    //         <Stack verticalAlign="space-around" horizontalAlign="center">
    //             <OverflowSet
    //                 items={[]}
    //                 overflowItems={[
    //                     {
    //                         key: 'item1',
    //                         name: 'Nuevo Peligro',
    //                         iconProps: { iconName: "add" },
    //                         onClick: () => { openNuevoPeligro() }
    //                     },
    //                     {
    //                         key: 'item3',
    //                         name: 'Editar',
    //                         iconProps: { iconName: "edit" }
    //                     }
    //                 ]}
    //                 onRenderOverflowButton={onRenderOverflowButton}
    //                 onRenderItem={onRenderItem}
    //             />
    //         </Stack>
    //     )
    // },
];

const _onRenderRow: IDetailsListProps["onRenderRow"] = (props) => {
    const customStyles: Partial<IDetailsRowStyles> = {};
    if (props) {
        customStyles.root = {
            // margin: '5px 0 5px 0',
            // borderRadius: '5px',
            padding: "2px 0 2px 0",
            border: themeBase.theme.effects.elevation4,
        };
        customStyles.fields = {
            textAlign: "start",
            alignItems: "center",
        };
        return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
};
